<div class="container">
    <br>
    <br>
    <div class="row">
        <div class="col-3"></div>
        <div class="col-6">
            <mat-card class="fill-w">
                <img style="background-color: #fff;" mat-card-image src="/assets/images/csLogo.png" alt="Central Strone Logo">
                <mat-card-content>
                    <p>Please enter your username before proceeding.</p>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <br>
    <div class="row">
        <div class="col-4"></div>
        <div class="col-4">
            <mat-form-field class="fill-w">
                <mat-label>Username</mat-label>
                <input id="usernameInput" matInput type="text" placeholder="Username*" [(ngModel)]="username" (keydown.enter)="login()"/>
            </mat-form-field>
        </div>
    </div>
    <div class="row" *ngIf="errorMessage.length>0">
        <div class="col-4"></div>
        <div class="col-4" style="color: red;">
            {{errorMessage}}
        </div>
    </div>
    <div class="row">
        <div class="col-4"></div>
        <div class="col-4">
            <button mat-raised-button color="primary" class="fill-w" [disabled]="disableLoginButton || username.length < 5" (click)="login()"  > Continue </button>
        </div>
    </div>
    
</div>